import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { EErrorMessages } from 'app/types/errorMessages';
import { pluralize } from '@helpers/pluralize';
import { useAPI } from '@providers/useAPI';
import { useMutation } from '@tanstack/react-query';
import { PromptsService } from 'app/API';
import { DiffMethod } from 'react-diff-viewer-continued';
import toast from 'react-hot-toast';
import { Diff } from './components/Diff';
import { TProps } from './types/Props';

export const PreviewPrompt = ({ left, right, slug, systemPrompt, manualReload, setStage }: TProps) => {
  const { call } = useAPI();
  const leftLines = left.split('\n').length ?? 0;
  const rightLines = right.split('\n').length ?? 0;

  const updateTemplateMutation = useMutation({
    mutationFn: () =>
      call(() => PromptsService.updatePromptTemplate({ requestBody: { slug, template: right, systemPrompt } }), {
        onError: (message) => {
          manualReload();
          toast.error(message || EErrorMessages.DEFAULT);
        },
      }),
    onSuccess: () => {
      manualReload();
      toast.success('Updated successfully');
    },
  });

  return (
    <div className="second-stage">
      <div className="flex-block">
        <div className="left-wrapper">
          <div className="lines">
            {leftLines} {pluralize(leftLines, 'line', `lines`)}
          </div>
        </div>
        <div className="right-wrapper">
          <div className="lines">
            {rightLines} {pluralize(rightLines, 'line', `lines`)}
          </div>
        </div>
      </div>
      <div className="diff">
        <Diff left={left} right={right} method={DiffMethod.WORDS_WITH_SPACE} />
      </div>
      <div className="flex justify-center items-center">
        <Button
          onClick={() => {
            setStage('edit');
          }}
          className="mr-4"
        >
          Back
        </Button>
        <Button
          onClick={() => {
            updateTemplateMutation.mutate();
          }}
        >
          Save changes
        </Button>
      </div>
    </div>
  );
};
